import React from 'react'
import { Box, IconButton, Stack, Typography } from '@mui/material'
import { Close } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import { GenerateQRCode } from '../../../components/GenerateQRCode'

export const DigitalTicket = () => {
  const navigate = useNavigate()
  const handleClose = () => {
    navigate("/home");
  }

  return (
    <Box sx={{ backgroundColor: '#000' ,backgroundImage: 'FORTUNE_PRECIOUS.jpg', height: '100vh' }}>
      <IconButton sx={{ color: 'white', padding: '5px' }} onClick={handleClose}>
        <Close fontSize='large' />
      </IconButton>
      <Stack sx={{ position: 'absolute', top: '30%', alignItems: 'center', justifyContent: 'center' }} color='white' spacing={2}>
        <GenerateQRCode />
        <Typography width='70%' textAlign='center'>
          This QR code must be kept private to ensure privacy with your profile and ticket credentials.
        </Typography>
      </Stack>
    </Box>
  )
}
